/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { LoadingType } from "src/components/Layout/LoadingWrapper"; //@todo move this type...
import { FullScreenSpinner } from "src/components/UI/Loading/Spinners/FullScreenSpinner";
import { InlineSpinner } from "src/components/UI/Loading/Spinners/InlineSpinner";

interface Props {
  type: LoadingType;
}
export function Loading({ type }: Props) {
  return (
    <>
      {(() => {
        switch (type) {
          case LoadingType.Fullscreen:
            return <FullScreenSpinner />;
          case LoadingType.Inline:
            return <InlineSpinner />;
          case LoadingType.Hidden:
            return <> </>;
        }
      })()}
    </>
  );
}
